module.exports = __webpack_public_path__ + "static/media/agrasenlogo.ac315e5f.png";